import { createContext, useContext } from "react"

import { ObjectCardContextValues } from "./ObjectCard.types"

export const ObjectCardContext = createContext<ObjectCardContextValues | undefined>(undefined)
ObjectCardContext.displayName = "ObjectCard"

export default function useObjectCard(): ObjectCardContextValues {
    const context = useContext(ObjectCardContext)
    if (!context) {
        throw new Error("useObjectCard must be used within an ObjectCard component")
    }

    return context
}
